(function () {
    'use strict';

    var uploadImage2 = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/gallery/components/uplpadImage.html',
        controllerAs: 'userCtrl',
        bindings: {
            photoAll:'=',
            folderId:'=',
            qiniuId:'=',
            uploadPhotoItem:'=',
            aid:'='
        },

        controller: ['$scope', '$stateParams', '$q', '$localStorage', 'Qinius','QiniuToken','PlatformWechatSetting', 'Customer', 'WxJS', 'Theme', 'Gallery','SweetAlert','$rootScope','ImageService','UidService','Convert','$timeout','$state','CommonService',
            function ($scope, $stateParams, $q, $localStorage, Qinius, QiniuToken, PlatformWechatSetting, Customer, WxJS, Theme, Gallery, SweetAlert,$rootScope,ImageService,UidService,Convert,$timeout,$state,CommonService) {
                var vm = this;
                // 成功多少张
                console.log(vm.folderId,'folder');
                vm.indd = 0;
                vm.errorImageArr = [];
                vm.duplicateList = [];
                vm.filesLength = 0;
                vm.detectFaces = $state.current.name !== "editorPhotoBothEdit" && $state.current.name !== 'editorPhotoBoth'
                var repeatCount = 0;
                var cancelledCount = 0;
                var localIdsArr = [];
                vm.uploadFiles = []
                if (window.location.href.indexOf("?") > -1) {
                    var r = window.location.href.split('?')[1];
                    var typeFlag = r.split('&')[0].split('=')[1];
                    var distinguish = decodeURIComponent(typeFlag);
                    if (distinguish == 'weChatApplet' || distinguish == 'weChatAppletMake') {
                        vm.uploadType = 'wechat';
                    }else if(distinguish == 'toutiaoApp'){
                        vm.uploadType = 'byteDance';
                    }else if(distinguish == 'alipayApp'){
                        vm.uploadType = 'ali';
                    }
                }else{
                    vm.uploadType = 'wechat';
                }
                function addAlertClass() {
                    setTimeout(function () {
                        $(".sweet-alert").addClass('folder-alert').addClass('whiteBg');
                    })
                }
                function removeAlertClass() {
                    setTimeout(function () {
                        $(".sweet-alert").removeClass('folder-alert').removeClass('whiteBg');
                        $(".sa-button-container").removeClass('folder-alert-top')
                        $(".sa-button-container .cancel").removeClass('folder-alert-right')
                    },200)
                }

                //生成缩略图
                function dataURLtoBlob(dataurl) {
                    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }
                    return new Blob([u8arr], {type: mime});
                }
                if (wx) {
                    var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                    // var url = "https://stage.fotavatar.com/10/544/gallery/uploading/1230814023448763";
                    WxJS.get({url: url}, function (config) {
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.data.appId, // 必填，公众号的唯一标识
                            timestamp: config.data.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.data.nonceStr, // 必填，生成签名的随机串
                            signature: config.data.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'previewImage', 'uploadImage','getLocalImgData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            // console.log('editor: wechat api ready!');
                        });
                        wx.error(function (res) {
                            // alert("wx.error: "+res.errMsg)
                            // console.log(res);
                        });
                    }, function (res) {
                    });
                }

                $scope.domains = Qinius.getDomain();
                var unsubQiniuToken = QiniuToken.subscribe('tokenWithPolicy', {"mimeLimit":"image/jpeg;image/png"}, function (token) {
                    vm.token = token;
                });
                $scope.$on('$destroy', unsubQiniuToken);

                vm.storeId = $stateParams.storeId;
                vm.platformSetting = PlatformWechatSetting.get();
                vm.customer = Customer.current();
                $q.all([$scope.domains.$promise]).then(function(){
                    $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                    // token过期 — QiniuToken 单例自动刷新
                    //安卓
                    $scope.$on('clickAndroidUpload', function(event, args) {
                        vm.indd = 0;
                        if(vm.uploadType=='ali'){
                            ap.chooseImage({
                                sourceType: ['camera', 'album'],
                                sizeType: ['original'],
                                count: 9
                            }, function(res){
                                var files = []
                                for (var i = 0; i < res.apFilePaths.length; i++) {
                                    var tempFile = res.tempFiles[i];
                                    var fileName = tempFile.name || tempFile.fileName || tempFile.path && tempFile.path.split('/').pop() || '';
                                    files.push({
                                        localId:res.apFilePaths[i],
                                        blobCover:res.apFilePaths[i],
                                        imgSize:tempFile.size,
                                        fileName: fileName || 'IMG_' + Date.now() + '_' + i + '.jpg'
                                    })
                                }
                                vm.indd = 0;
                                vm.errorImageArr = [];
                                vm.duplicateList = [];
                                vm.filesLength = files.length;
                                $(".save-pages2").removeClass('hide1');

                                angular.forEach(files,function (file1,index1) {
                                    (function (file,index) {
                                        toBase64(file,index)
                                    })(file1,index1)
                                })
                                function toBase64(file,i) {
                                    var image = new Image();
                                    image.crossOrigin = 'anonymous';
                                    image.size = file.imgSize
                                    image.onload = function() {
                                        var canvas = document.createElement('CANVAS');
                                        var context = canvas.getContext('2d');
                                        canvas.height = image.height;
                                        canvas.width = image.width;
                                        context.drawImage(image, 0, 0);
                                        try {
                                            var dataURL = canvas.toDataURL('image/jpeg');
                                            file.blobCover = dataURL;
                                            Convert.downloadImg4AliH5AngUpload7Niu({
                                                base64:dataURL,
                                                type:"gallery"
                                            },function (res) {
                                                uploadGalleries(file, res, i)
                                            })
                                        } catch (e) {
                                            if(i==files.length-1){
                                                updatePic()
                                            }
                                        }
                                        canvas = null;
                                    }
                                    image.src = file.localId;
                                }

                                function uploadGalleries(file, res, i) {
                                    var originalFileName = file.fileName || ('IMG_' + Date.now() + '_' + i + '.jpg');
                                    var params = {
                                        articleId:vm.aid,
                                        identifiers: res.message,
                                        provider: "QINIU",
                                        fileName: originalFileName,
                                        folderId: vm.folderId ? vm.folderId : '',
                                        check: true,
                                        type: vm.uploadType,
                                        hash:res.hash,
                                        detectFaces:vm.detectFaces
                                    };
                                    Gallery.upload(params, function (resp) {
                                        if (resp.data.cancelled) {
                                            cancelledCount += 1;
                                        }

                                        file.loading = true;
                                        file.usenum = 0;
                                        file.id = resp.data.id;
                                        file.width = resp.data.width;
                                        file.height = resp.data.height;
                                        file.imgsize = resp.data.imgSize;
                                        file.cancelled = resp.data.cancelled;
                                        file.identifier = resp.data.identifier;
                                        if(resp.data.duplicate){
                                            vm.duplicateList.push(resp)
                                        }
                                        vm.uploadFiles.push(resp)
                                        vm.indd++;
                                        // 上传成功
                                        if (files.length == (vm.indd + vm.errorImageArr.length)) {
                                            $timeout(function () {
                                                $scope.loadingAllSuccess = true;
                                                updatePic();
                                            },500);
                                        }

                                    },function () {
                                        vm.errorImageArr.push(file);
                                        if (files.length == (vm.indd + vm.errorImageArr.length)) {
                                            $timeout(function () {
                                                $scope.loadingAllSuccess = true;
                                                updatePic();
                                            },500);
                                        }
                                    })
                                }
                            });
                        }else{

                            /********************************************
                             * 微信端上传图片功能
                             * 使用原生 <input type="file" multiple> 替代 wx.chooseImage + wx.getLocalImgData
                             * 优势：1) 可获取原始文件名  2) 可获取原图数据（不经微信JSSDK压缩）
                             * 与 iOS 端 uploadImageMutiple 流程保持一致
                             ********************************************/
                            vm.indd = 0;  //成功的张数
                            vm.errorImageArr = [];  //错误的张数

                            // 创建隐藏的 file input 用于微信端选图
                            var wechatFileInput = document.createElement('input');
                            wechatFileInput.type = 'file';
                            wechatFileInput.accept = 'image/png, image/jpeg, image/jpg, .heic, .heif, .livp';
                            wechatFileInput.multiple = true;
                            wechatFileInput.style.display = 'none';
                            wechatFileInput.id = 'wechatUploadInput';
                            document.body.appendChild(wechatFileInput);
                            console.log(1111111);
                            wechatFileInput.onchange = function(event) {
                                $timeout(function() {
                                    $scope.bigSizeTip = false;
                                    var files = [];
                                    cancelledCount = 0;
                                    var rawFiles = event.target.files;
                                    for (var i = 0; i < rawFiles.length; i++) {
                                        var file = rawFiles[i];
                                        // 过滤非图片文件
                                        var lowerName = (file.name || '').toLowerCase();
                                        var isValidImage = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/heic';
                                        var isHeicExt = !file.type && (lowerName.endsWith('.heic') || lowerName.endsWith('.heif'));
                                        var isLivp = !file.type && lowerName.endsWith('.livp');
                                        if (isValidImage || isHeicExt || isLivp) {
                                            file.usenum = 0;
                                            file.percent = 0;
                                            file.blobCover = URL.createObjectURL(file);
                                            files.push(file);
                                        }
                                    }

                                    if (files.length === 0) {
                                        // 清理临时 input
                                        document.body.removeChild(wechatFileInput);
                                        return;
                                    }

                                    $(".save-pages2").removeClass('hide1');

                                    // 检查图片大小
                                    vm.higherSize = [];
                                    angular.forEach(files, function (item, index) {
                                        item.imgSize = item.size;
                                        if (item.size / 1024 > 51200) {
                                            vm.higherSize.push(item);
                                        }
                                    });

                                    // 系统检测到大于20M的图片
                                    if (vm.higherSize.length > 0) {
                                        $scope.bigSizeTip = true;
                                        $scope.higherSizeLen = vm.higherSize.length;
                                        $scope.$digest();
                                    } else {
                                        if (files.length > 0) {
                                            filterUpload(files);
                                        }
                                    }

                                    $scope.filterBigSize = function () {
                                        $scope.bigSizeTip = false;
                                        files = files.filter(function (item, index) {
                                            return item.size / 1024 < 51200;
                                        });
                                        if (files.length === 0) {
                                            updatePic();
                                        } else {
                                            filterUpload(files);
                                        }
                                    };

                                    // 清理临时 input
                                    try {
                                        document.body.removeChild(wechatFileInput);
                                    } catch (e) {}
                                });
                            };

                            // 触发文件选择
                            wechatFileInput.click();
                        }
                    });

                    /**
                     * iOS上传
                     * 使用自带的上传图片功能  不调用微信的jssdk
                     * 非调用微信公众号上传图片 无9张限制 可多张上传 上传到七牛  并且可以返回路径在页面显示
                     * @param $event
                     */
                    window.uploadImageMutiple = function ($event) {
                        $timeout(function () {
                            uploadImageMutipleCb($event)
                        })
                    };
                });


                function uploadImageMutipleCb($event) {
                    $scope.bigSizeTip = false;
                    var files = [];
                    cancelledCount = 0;
                    for (var i = 0; i < $event.target.files.length; i++) {
                        var file = $event.target.files[i];
                        // image/png, image/jpeg, image/jpg, image/heic, .heic, .heif, .livp
                        var lowerName = (file.name || '').toLowerCase();
                        var isValidImage = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/heic';
                        var isHeicOrLivp = !file.type && (lowerName.endsWith('.heic') || lowerName.endsWith('.heif') || lowerName.endsWith('.livp'));
                        if (isValidImage || isHeicOrLivp) {
                            file.usenum = 0;
                            file.percent = 0;
                            file.blobCover = URL.createObjectURL(file);
                            files.push(file)
                        }
                    }
                    if(files.length == 0){
                        return
                    }

                    vm.higherSize = [];
                    angular.forEach(files, function (item, index) {
                        item.imgSize = item.size;
                        if (item.size / 1024 > 51200) {
                            vm.higherSize.push(item);
                        }
                    });
                    //系统检测到{{}}张大于20M的图片，已自动过滤\n请压缩后再尝试上传！
                    if (vm.higherSize.length > 0) {
                        $scope.bigSizeTip = true;
                        $scope.higherSizeLen = vm.higherSize.length;
                        $scope.$digest();
                    } else {
                        filterUpload(files);
                    }

                    $scope.filterBigSize = function () {
                        $scope.bigSizeTip = false;
                        files = files.filter(function (item, index) {
                            return item.size / 1024 < 51200;
                        });
                        if (files.length == 0) {
                            updatePic();
                        } else {
                            filterUpload(files);
                        }
                    }
                }

                function filterUpload(files) {
                    $(".save-pages2").removeClass('hide1');
                    // 预处理 .livp 文件：解包提取 HEIC 图片后替换，后续流程无感知
                    extractLivpFiles(files).then(function(processedFiles) {
                        if (processedFiles.length === 0) {
                            $(".save-pages2").addClass('hide1');
                            return;
                        }
                        asyncUpload(processedFiles);
                    });
                }

                // 遍历文件列表，将 .livp 文件解包为真实图片文件，非 .livp 文件原样返回
                function extractLivpFiles(files) {
                    var promises = [];
                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];
                        var fileName = (file.name || '').toLowerCase();
                        if (fileName.endsWith('.livp')) {
                            promises.push(_extractHeicFromLivp(file));
                        } else {
                            promises.push(Promise.resolve(file));
                        }
                    }
                    return Promise.all(promises).then(function(results) {
                        return results.filter(function(f) { return f !== null; });
                    });
                }

                // 从 .livp 压缩包中提取 HEIC 图片，保留原始 .livp 文件名
                function _extractHeicFromLivp(file) {
                    return JSZip.loadAsync(file).then(function(zip) {
                        var imageFileName = null;
                        zip.forEach(function(relativePath, zipEntry) {
                            if (!zipEntry.dir && !imageFileName) {
                                var lowerName = relativePath.toLowerCase();
                                if (lowerName.endsWith('.heic') || lowerName.endsWith('.heif') ||
                                    lowerName.endsWith('.jpg') || lowerName.endsWith('.jpeg') ||
                                    lowerName.endsWith('.png')) {
                                    imageFileName = relativePath;
                                }
                            }
                        });

                        if (!imageFileName) {
                            console.warn('No image found in .livp package:', file.name);
                            return null;
                        }

                        return zip.file(imageFileName).async('blob').then(function(blob) {
                            // 提取内部图片的扩展名
                            var internalExt = '';
                            var internalLower = imageFileName.toLowerCase();
                            if (internalLower.endsWith('.heic')) internalExt = '.heic';
                            else if (internalLower.endsWith('.heif')) internalExt = '.heif';
                            else if (internalLower.endsWith('.jpg') || internalLower.endsWith('.jpeg')) internalExt = '.jpg';
                            else if (internalLower.endsWith('.png')) internalExt = '.png';
                            // 用原始 .livp 文件名替换扩展名
                            var newName = file.name.replace(/\.livp$/i, '') + internalExt;
                            var newFile = new File([blob], newName, { type: blob.type || 'image/heic' });
                            newFile.usenum = 0;
                            newFile.percent = 0;
                            newFile.blobCover = URL.createObjectURL(newFile);
                            newFile.imgSize = blob.size;
                            return newFile;
                        });
                    }).catch(function(err) {
                        console.error('Failed to extract .livp:', file.name, err);
                        return null;
                    });
                }

                function asyncUpload(files) {
                    vm.uploadPhotoItem = files;
                    vm.indd = 0;
                    vm.errorImageArr = [];
                    vm.duplicateList = [];
                    vm.uploadFiles = [];  // 重置已上传文件列表，避免旧数据残留
                    $rootScope.$broadcast('uploadStart',true);
                    vm.filesLength = vm.uploadPhotoItem.length;
                    qiniuUpload(vm.uploadPhotoItem[0], vm.uploadPhotoItem, 0);

                }

                /**
                 * 上传前先补齐图片真实宽高：
                 * width/height 不是 File 原生属性，可能是调用方没赋值，也可能异步还没回来，
                 * 直接判断会变成 undefined > 30000 = false，导致大图漏判。
                 * 这里统一走 缓存 -> Image 解码 -> 文件头解析 三级兜底，拿到宽高后再上传。
                 */
                function qiniuUpload(file, files, index_) {
                    var startUpload = function () {
                        doQiniuUpload(file, files, index_);
                    };
                    try {
                        CommonService.readImageDimensions(file).then(function (dim) {
                            if (dim && dim.width > 0 && dim.height > 0) {
                                file.width = dim.width;
                                file.height = dim.height;
                            }
                            startUpload();
                        }, startUpload);
                    } catch (e) {
                        // 兜底：读取宽高异常时不能阻塞上传，仅按文件大小判断
                        startUpload();
                    }
                }

                function doQiniuUpload(file, files, index_) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);
                    var _key ="gallery-" + UidService.get()
                    // 超过20M / 单边超过30000 / 超过1.5亿像素 增加xl大图标识
                    // 宽高实在拿不到时（返回0）由文件大小兜底，避免 NaN 导致判断失效
                    var fileWidth = Number(file.width) || 0;
                    var fileHeight = Number(file.height) || 0;
                    var isXL = CommonService.isExtraLargeImage(file);
                    console.log('[upload]' + file.name, 'size:' + (file.size || 0), 'width:' + fileWidth, 'height:' + fileHeight, 'isXL:' + isXL);
                    if(isXL){
                        _key += '-xl'
                    }
                    formData.append('key', _key);
                    formData.append('token', vm.token);
                    file.percent = 20;

                    var reader = new FileReader();
                    reader.readAsArrayBuffer(file)
                    reader.onloadend = function (e) {
                        formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                        return $.ajax({
                            // cache: true,
                            type: "POST",
                            url: 'https://upload.qiniup.com/',
                            data: formData,
                            async: true,
                            contentType: false,
                            processData: false,
                            xhr:function(){
                                var myXhr = $.ajaxSettings.xhr();
                                if(myXhr.upload){ // check if upload property exists
                                    myXhr.upload.addEventListener('progress',function(e){
                                        var loaded = e.loaded;                  //已经上传大小情况
                                        var total = e.total;                      //附件总大小
                                        var percent = Math.floor(100*loaded/total)+"%";     //已经上传的百分比
                                        file.percent = parseInt(100*loaded/total)/2;
                                    }, false); // for handling the progress of the upload
                                }
                                return myXhr;
                            },
                            success: function (data) {
                                vm.uploadPhotoItem[index_].blobCover = $scope.domain +data.key + '?imageView2/1/w/150/h/150';
                                file.percent = 80;
                                if (files.length > Number(index_) + 1) {
                                    var f = files[index_ + 1];
                                    qiniuUpload(f, files, index_ + 1);
                                }
                                assignGalleries(file, files, index_, data)
                            },
                            error: function (request) {
                                file.state = 'error';
                                vm.errorImageArr.push(files[index_]);
                                //最后一个失败了的话
                                if (files.length == (vm.indd + vm.errorImageArr.length)) {
                                    $timeout(function () {
                                        $scope.loadingAllSuccess = true;
                                        updatePic();
                                    })
                                }else{
                                    if (files.length > Number(index_) + 1) {
                                        var f = files[index_ + 1];
                                        qiniuUpload(f, files, index_ + 1);
                                    }
                                }
                            }
                        });
                    }
                }

                function serviceUpload(data, file, callback) {
                    // 兜底：若 file.name 为空（微信JSSDK限制导致），生成时间戳文件名
                    var finalFileName = file.name || ('IMG_' + (function(){
                        var now = new Date();
                        var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
                        return now.getFullYear().toString() + pad(now.getMonth()+1) + pad(now.getDate())
                            + '_' + pad(now.getHours()) + pad(now.getMinutes()) + pad(now.getSeconds());
                    })() + '.jpg');
                    Gallery.upload({
                        identifiers: data.key,
                        provider: "QINIU",
                        fileName: finalFileName,
                        imgSize: file.size,
                        width: file.width,
                        height: file.height,
                        folderId: vm.folderId ? vm.folderId : '',
                        check: true,
                        type: vm.uploadType,
                        articleId:vm.aid,
                        hash:data.hash,
                        detectFaces:vm.detectFaces
                    }, function (resp) {
                        file.percent = 100;
                        file.id = resp.data.id;
                        file.cancelled = resp.data.cancelled;
                        vm.indd++;
                        file.state = 'success';
                        $timeout(function () {
                            if (!resp.data.cancelled) {
                                if(vm.photoAll){
                                    vm.photoAll.push(resp.data)
                                }
                                if(vm.qiniuId){
                                    resp.data.identifier = $scope.domain +resp.data.identifier;
                                    resp.data.usenum = 0;
                                    resp.data.loading = 0;
                                    vm.qiniuId.push(resp.data)
                                }
                                vm.uploadFiles.push(resp.data)
                            }
                            if(resp.data.duplicate){
                                vm.duplicateList.push(resp.data)
                            }
                            if(callback){callback()}

                        },1000)
                    }, function (error) {
                        file.state = 'error';
                        vm.errorImageArr.push(file);
                        if(callback){callback()}
                    });
                }


                function assignGalleries(file, files, index_, data) {
                    serviceUpload(data, file,function () {
                        if (files.length == (vm.indd + vm.errorImageArr.length)) {
                            $timeout(function () {
                                $scope.loadingAllSuccess = true;
                                updatePic(files);
                            },500)
                        }else{
                            // if (files.length > Number(index_) + 1) {
                            //     var f = files[index_ + 1];
                            //     qiniuUpload(f, files, index_ + 1);
                            // }
                        }
                    });
                }
                $scope.reUpload = function () {
                    $scope.errorImageArr_.forEach(function (item) {
                        item.percent = 0;
                        item.state = null;
                    })
                    asyncUpload($scope.errorImageArr_);
                    $scope.errorImageHide();
                    $(".save-pages2").removeClass('hide1');
                }
                // 上传图片后更新图片库/文件夹
                function updatePic(files) {
                    $scope.isLookErrorImages = false;
                    if (vm.duplicateList && vm.duplicateList.length > 0) {
                        if(files.length == (vm.indd + vm.errorImageArr.length)){
                            $timeout(function(){
                                $rootScope.$broadcast('duplicateImages', angular.copy(vm.duplicateList),true,files,vm.uploadFiles);
                            })
                        }
                    }else{
                        $rootScope.$broadcast('uoloadFinished',true,files,vm.uploadFiles);
                    }
                    vm.uploadPhotoItem = [];
                    $(".save-pages2").addClass('hide1');
                    vm.indd = 0;
                    vm.filesLength = 0;
                    $timeout(function () {
                        //如果没有上传错误图片，关闭提示框
                        if(vm.errorImageArr.length === 0){
                            $scope.loadingAllSuccess = false;
                            if(!$scope.isLookErrorImages){
                                vm.errorImageArr = [];
                            }
                        }
                    },2000)

                }
                //关闭上传错误弹窗
                $scope.closeErrorMoadl = function (){
                    var target = event.target;
                    if($(target).hasClass("z-modal") || $(target).hasClass("close-btn") || $(target).hasClass("close-icon1")){
                        $scope.loadingAllSuccess = false;
                    }

                }
                //上传进度获取
                $scope.schedule = function () {
                    if(vm.filesLength > 0){
                        return Number(vm.indd)+vm.errorImageArr.length + '/' + vm.filesLength
                    }
                }
                $scope.errorImageArrCb = function () {
                    return vm.errorImageArr.length
                }
                $scope.successImageArrCb = function () {
                    return vm.indd
                }
                $scope.isLookErrorImages = false;
                $scope.lookErrorImages = function () {
                    $scope.isLookErrorImages = true;
                    $scope.loadingAllSuccess = false;
                    $scope.errorImageArr_ = vm.errorImageArr;
                    $scope.errorImageArr_.forEach(function (item) {
                        item.percent = 0;
                    })
                };
                $scope.errorImageHide = function () {
                    $scope.isLookErrorImages = false;
                }

                function threeInfo(item){
                    $scope.threeError = true;
                    $scope.threeErrorText=item;
                    $timeout(function () {
                        $scope.threeError = false;
                        $scope.threeErrorText="";
                    },1500)
                }
            }]
    };

    angular
        .module('editorApp')
        .component('uploadImage2', uploadImage2);
})();
